import { Bell, ClipboardCheck, LayoutDashboard, LayoutGrid, Users, Wallet } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

/** Field payroll ops. Admins also get it so the hub and supervisor rosters stay one click away. */
export function buildPayrollOpsGroup(ctx: StaffNavContext): StaffNavGroup | null {
  if (!ctx.showPayroll && !ctx.showPayrollAdmin) return null

  const children: StaffNavNode[] = []

  if (ctx.showPayrollAdmin) {
    children.push(
      leaf(
        'payroll_admin_dashboard',
        'Dashboard',
        AppPaths.payrollAdminDashboard,
        LayoutDashboard,
        ['dashboard', 'executive', 'payroll dashboard', 'gp', 'cash'],
      ),
    )
  }

  if (ctx.showPayroll) {
    children.push(
      leaf('payroll_overview', 'Overview', AppPaths.payroll, Wallet, [
        'payroll hub',
        'overview',
      ]),
      leaf(
        'payroll_daily_attendance',
        'Daily Attendance',
        AppPaths.payrollDailyAttendance,
        ClipboardCheck,
        ['attendance', 'grid', 'consolidate'],
        { activeWhenPrefix: true },
      ),
      leaf(
        'payroll_supervisors',
        'Supervisors',
        AppPaths.payrollSupervisorRosters,
        Users,
        ['supervisor', 'roster', 'scope', 'supervisor management'],
        { activeWhenPrefix: true },
      ),
    )
  }

  if (ctx.showPayrollAdmin) {
    children.push(
      leaf(
        'payroll_admin_console',
        'Payroll Console',
        AppPaths.payrollAdminConsole,
        LayoutGrid,
        ['payroll admin', 'console', 'pay runs', 'identity', 'staff roster', 'admin console'],
        {
          activeWhenPrefix: true,
          // Dashboard is its own leaf under /payroll/admin/dashboard.
          activeExcludePrefixes: [AppPaths.payrollAdminDashboard],
        },
      ),
    )
  }

  if (ctx.showAttendanceAlertsNav) {
    children.push(
      leaf(
        'attendance_alerts',
        'Attendance alerts',
        AppPaths.adminAttendanceAlerts,
        Bell,
        ['alerts', 'boss', 'email', 'supervisor marking', 'attendance report'],
        { activeWhenPrefix: true },
      ),
    )
  }

  return group('payroll_ops', 'Payroll', Wallet, ['salary', 'attendance', 'supervisor', 'dashboard'], children)
}
